import _ from "lodash";
import { randomstring } from "randomstring-js";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
} from "NetworkCall";
import { INSTANCE_URL, BASE_IMAGES_URL, itemCount } from "Constants";

export const COURSE_WIZARD_CURRENT_STEP = "COURSE_WIZARD_CURRENT_STEP";
export const COURSE_WIZARD_ALL_STEPS = "COURSE_WIZARD_ALL_STEPS";
export const COURSE_ALL_LIST = "COURSE_ALL_LIST";
export const ALL_COURSE_NAMES = "ALL_COURSE_NAMES";
export const COURSE_ALL_UNPUBLISHED_LIST = "COURSE_ALL_UNPUBLISHED_LIST";
export const COURSE_LIST = "COURSE_LIST";
export const QUIZ_LIST = "QUIZ_LIST";
export const COURSE_LESSON_MODAL = "COURSE_LESSON_MODAL";
export const LESSON_TEXT_ATTACHMENT = "LESSON_TEXT_ATTACHMENT";
export const LESSON_DOCUMENT_ATTACHMENT = "LESSON_DOCUMENT_ATTACHMENT";
export const LESSON_VIDEO_ATTACHMENT = "LESSON_VIDEO_ATTACHMENT";
export const LESSON_AUDIO_ATTACHMENT = "LESSON_AUDIO_ATTACHMENT";
export const LESSON_LINK_ATTACHMENT = "LESSON_LINK_ATTACHMENT";
export const COURSE_CURRENT_CHAPTER_OPENED = "COURSE_CURRENT_CHAPTER_OPENED";
export const TEMPORARY_CHAPTER_RANKING = "TEMPORARY_CHAPTER_RANKING";
export const TEMPORARY_LESSON_RANKING = "TEMPORARY_LESSON_RANKING";
export const EDIT_LESSON_DATA = "EDIT_LESSON_DATA";
export const CHAPTER_MODAL = "CHAPTER_MODAL";
export const COURSE_MODAL = "COURSE_MODAL";

export function fetchCurrentStep(step) {
  return { type: COURSE_WIZARD_CURRENT_STEP, payload: step };
}

export function fetchTabList(tabs) {
  return { type: COURSE_WIZARD_ALL_STEPS, payload: tabs };
}

export function fetchAllCourses(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=*&include_count=true&filter=(${filter})&order=createdon%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=sessionspeakers_by_courseid,course_chapter_by_courseid,course_lessons_by_courseid,course_lessons_attachments_by_courseid,tickets_by_ticketid&include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COURSE_ALL_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchAllCoursesNames(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?fields=courseid,coursename&include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: ALL_COURSE_NAMES,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchAllUnpublishedCourses(session, courseid = "", callback) {
  var filter = encodeURI(`(eventid=${session.eventid}) AND (ispublished=0)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=sessionspeakers_by_courseid,course_chapter_by_courseid,course_lessons_by_courseid,course_lessons_attachments_by_courseid,tickets_by_ticketid&include_count=true&filter=(${filter})&order=createdon%20DESC`;
  if (courseid != "") {
    var filter = encodeURI(
      `(eventid=${session.eventid}) AND (courseid=${courseid})`
    );
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=sessionspeakers_by_courseid,course_chapter_by_courseid,course_lessons_by_courseid,course_lessons_attachments_by_courseid,tickets_by_ticketid&include_count=true&filter=(${filter})`;
  }

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COURSE_ALL_UNPUBLISHED_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchCourses(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${perPage}&offset=${offset}`;
  var filter = encodeURI(`(eventid=${session.eventid})`);

  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=*&include_count=true&filter=(${filter})&${offSetQuery}&order=createdon%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=sessionspeakers_by_courseid,course_chapter_by_courseid,course_lessons_by_courseid,course_lessons_attachments_by_courseid,tickets_by_ticketid&include_count=true&filter=(${filter})&${offSetQuery}&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COURSE_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function searchCourses(session, search = "", pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${perPage}&offset=${offset}`;
  let searchQuery = `coursename like %${search}%`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=*&include_count=true&filter=(${filter})&${offSetQuery}&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COURSE_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchQuiz(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    limit: perPage,
    offset: offset,
    eventid: session.eventid,
    type: "fetchQuizForm",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (res) => {
        dispatch({
          type: QUIZ_LIST,
          payload: { data: res.response, count: res.count },
        });
      },
      (error) => {}
    );
  };
}

export function handleLessonModal(obj) {
  return { type: COURSE_LESSON_MODAL, payload: obj };
}

export function saveCourse(session, values, callback) {
  values = { ...values, eventid: session.eventid };
  let coverImage = values.coverimagehidden ? values.coverimagehidden : "";
  let coverVideo =
    values.covervideohidden && values.covervideohidden.file
      ? values.covervideohidden
      : "";

  return (dispatch) => {
    if (
      coverImage &&
      coverImage.search(";base64,") > 0 &&
      coverVideo &&
      coverVideo.file.search(";base64,") > 0
    ) {
      uploadCourseCoverImage(session, coverImage, dispatch, (profile) => {
        if (profile.success) {
          let videos = [coverVideo];
          uploadCourseCoverVideo(session, videos, dispatch, (video) => {
            if (video.success) {
              values = {
                ...values,
                coverimage: profile.data.path,
                covervideo: video.data[0].path,
                covervideothumbnail: video.data[0].thumbnail,
              };
              dispatch(createUpdateCourse(session, values, callback));
            } else {
              callback({ success: 3, data: video.message });
            }
          });
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (coverImage && coverImage.search(";base64,") > 0 && !coverVideo) {
      uploadCourseCoverImage(session, coverImage, dispatch, (profile) => {
        if (profile.success) {
          values = { ...values, coverimage: profile.data.path };
          dispatch(createUpdateCourse(session, values, callback));
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (
      !coverImage &&
      coverVideo &&
      coverVideo.file &&
      coverVideo.file.search(";base64,") > 0
    ) {
      let videos = [coverVideo];
      uploadCourseCoverVideo(session, videos, dispatch, (video) => {
        if (video.success) {
          values = {
            ...values,
            covervideo: video.data[0].path,
            covervideothumbnail: video.data[0].thumbnail,
          };
          dispatch(createUpdateCourse(session, values, callback));
        } else {
          callback({ success: 3, data: video.message });
        }
      });
    } else {
      values = { ...values };
      dispatch(createUpdateCourse(session, values, callback));
    }
  };
}

export function uploadCourseCoverImage(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/course/images/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function uploadCourseCoverVideo(session, videodata, dispatch, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadvideos`;
  let values = {
    eventid: session.eventid,
    data: videodata,
    path: "eventify/course/videos/",
  };

  postRequest(
    url,
    values,
    session,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function createUpdateCourse(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course`;
  var body = { resource: { ...values, eventid: session.eventid } };
  // if(values.courseid) {
  //     body = {resource: {...values}};
  // } else {
  //     body = {resource: {...values}};
  // }
  return (dispatch) => {
    if (values.courseid) {
      patchRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          // Update ticket name with course name
          if (values.ticketid) {
            var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;
            var body = {
              resource: { id: values.ticketid, ticketname: values.coursename },
            };

            patchRequest(
              url,
              body,
              session,
              dispatch,
              (data1) => {
                callback({ success: 1, data: data });
              },
              (error) => {
                callback({ success: 0, message: error });
              }
            );
          } else {
            callback({ success: 1, data: data });
          }
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, data: data });
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
}

export function deleteInstructor(session, values, callback) {
  var filter = encodeURI(
    `(eventid=${values.eventid}) AND (courseid=${values.courseid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addInstructor(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers`;
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function textAttachmentData(obj) {
  return { type: LESSON_TEXT_ATTACHMENT, payload: obj };
}

export function documentAttachmentData(obj) {
  return { type: LESSON_DOCUMENT_ATTACHMENT, payload: obj };
}

export function videoAttachmentData(obj) {
  return { type: LESSON_VIDEO_ATTACHMENT, payload: obj };
}

export function audioAttachmentData(obj) {
  return { type: LESSON_AUDIO_ATTACHMENT, payload: obj };
}

export function linkAttachmentData(obj) {
  return { type: LESSON_LINK_ATTACHMENT, payload: obj };
}

export function saveChapter(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_chapter`;
  var body = { resource: { ...values } };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteChapter(session, values, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (chapterid=${values.chapterid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_chapter?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function saveLesson(session, values, callback) {
  values = { ...values, eventid: session.eventid };

  let coverImage = values.coverimagehidden ? values.coverimagehidden : "";
  let coverVideo =
    values.covervideohidden && values.covervideohidden.file
      ? values.covervideohidden
      : "";

  return (dispatch) => {
    if (
      coverImage &&
      coverImage.search(";base64,") > 0 &&
      coverVideo &&
      coverVideo.file.search(";base64,") > 0
    ) {
      uploadLessonCoverImage(session, coverImage, dispatch, (profile) => {
        if (profile.success) {
          let videos = [coverVideo];
          uploadLessonCoverVideo(session, videos, dispatch, (video) => {
            if (video.success) {
              values = {
                ...values,
                coverimage: profile.data.path,
                covervideo: video.data[0].path,
                covervideothumbnail: video.data[0].thumbnail,
              };
              dispatch(createUpdateLesson(session, values, callback));
            } else {
              callback({ success: 3, data: video.message });
            }
          });
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (coverImage && coverImage.search(";base64,") > 0 && !coverVideo) {
      uploadLessonCoverImage(session, coverImage, dispatch, (profile) => {
        if (profile.success) {
          values = { ...values, coverimage: profile.data.path };
          dispatch(createUpdateLesson(session, values, callback));
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (
      !coverImage &&
      coverVideo &&
      coverVideo.file &&
      coverVideo.file.search(";base64,") > 0
    ) {
      let videos = [coverVideo];
      uploadLessonCoverVideo(session, videos, dispatch, (video) => {
        if (video.success) {
          values = {
            ...values,
            covervideo: video.data[0].path,
            covervideothumbnail: video.data[0].thumbnail,
          };
          dispatch(createUpdateLesson(session, values, callback));
        } else {
          callback({ success: 3, data: video.message });
        }
      });
    } else {
      values = { ...values };
      dispatch(createUpdateLesson(session, values, callback));
    }
  };
}

export function uploadLessonCoverImage(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/course/lessons/images/${randomstring(
    32
  )}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function uploadLessonCoverVideo(session, videodata, dispatch, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadvideos`;
  let values = {
    eventid: session.eventid,
    data: videodata,
    path: "eventify/course/lessons/videos/",
  };

  postRequest(
    url,
    values,
    session,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function createUpdateLesson(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    if (values.lessonid) {
      patchRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, data: data });
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, data: data });
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
}

export function courseCurrentChapterOpen(obj) {
  return { type: COURSE_CURRENT_CHAPTER_OPENED, payload: obj };
}

export function updateTemporaryChapterRanking(obj) {
  return { type: TEMPORARY_CHAPTER_RANKING, payload: obj };
}

export function updateSortedChapter(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_chapter`;
  var data = _.map(values, (obj) => ({
    chapterid: obj.chapterid,
    ranking: obj.ranking,
  }));
  var body = { resource: data, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateTemporaryLessonRanking(obj) {
  return { type: TEMPORARY_LESSON_RANKING, payload: obj };
}

export function updateSortedLessons(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons`;
  var data = _.map(values, (obj) => ({
    lessonid: obj.lessonid,
    ranking: obj.ranking,
  }));
  var body = { resource: data, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function editLesson(data) {
  return { type: EDIT_LESSON_DATA, payload: data };
}

export function fetchSingleLessonAttachment(session, data, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (lessonid=${data.lessonid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons_attachments?include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({
          success: 1,
          resource: data.resource,
          count: data.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function openChapterModal(obj) {
  return { type: CHAPTER_MODAL, payload: obj };
}

export function updateChapter(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_chapter`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function saveLessonAttachment(session, parent, attachments, callback) {
  var mainurl = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons_attachments`;
  var values = [];
  var promiseArray = [];
  var eventid = session.eventid;
  return (dispatch) => {
    deleteLessonAttachment(session, parent.lessonid, dispatch, (respo) => {
      if (respo.success) {
        _.map(attachments, (item, index) => {
          var obj = {
            eventid: session.eventid,
            courseid: parent.courseid,
            chapterid: parent.chapterid,
            lessonid: parent.lessonid,
          };
          obj.type = item.key;
          promiseArray.push(
            new Promise((resolve, reject) => {
              if (
                (item.key == "text" || item.key == "link") &&
                item.value != ""
              ) {
                obj.content = item.value;

                values.push(obj);
                resolve();
                // debugger;
              } else if (
                (item.key == "document" || item.key == "audio") &&
                item.file != ""
              ) {
                var file = item.file;
                var name = item.filename;
                var n = file.search(";base64,");
                if (n > 0) {
                  var content = file.split(";base64,")[1];
                  var filename = `eventify/${eventid}/course/lessons/attachments/${randomstring(
                    32
                  )}_${name}`;
                  var imageJson = {
                    resource: [
                      {
                        name: filename,
                        type: "file",
                        is_base64: true,
                        content: content,
                      },
                    ],
                  };
                  uploadEncodedFile(
                    `${BASE_IMAGES_URL}?check_exist=false`,
                    session,
                    imageJson,
                    dispatch,
                    (data) => {
                      obj.content = data.name;

                      values.push(obj);
                      resolve();
                    },
                    (error) => {
                      // callback({success:2, message:error});
                    }
                  );
                } else {
                  obj.content = file;

                  values.push(obj);
                  resolve();
                }
                // debugger;
              } else if (item.key == "video" && item.file != "") {
                var n = item.file.search(";base64,");
                if (n > 0) {
                  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadvideos`;
                  let videos = [{ file: item.file, filename: item.filename }];
                  let vidoedta = {
                    eventid: session.eventid,
                    data: videos,
                    path: "eventify/course/lessons/attachments/",
                  };

                  postRequest(
                    url,
                    vidoedta,
                    session,
                    dispatch,
                    (data) => {
                      obj.content = data[0].path;
                      obj.contentvideothumbnail = data[0].thumbnail;

                      values.push(obj);
                      resolve();
                    },
                    (error) => {}
                  );
                } else {
                  obj.content = item.file;
                  obj.contentvideothumbnail = item.thumbnail;

                  values.push(obj);
                  resolve();
                }
                // debugger;
              }
            })
          );
          // debugger;
        });

        Promise.all(promiseArray).then(() => {
          var body = { resource: values };
          postRequest(
            mainurl,
            body,
            session,
            dispatch,
            (data) => {
              callback({ success: 1, data: data });
            },
            (error) => {
              callback({ success: 0, message: error });
            }
          );
        });
      } else {
        callback({ success: 0, message: respo.message });
      }
    });
  };
}

export function deleteLessonAttachment(session, lessonid, dispatch, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (lessonid=${lessonid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons_attachments?filter=(${filter})`;

  deleteRequest(
    url,
    session,
    dispatch,
    (response) => {
      callback({ success: 1 });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function ticketAddUpdate(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;

  return (dispatch) => {
    if (values.ticketid) {
      var body = {
        resource: {
          id: values.ticketid,
          ticketname: values.coursename,
          tickettype: values.pricingtype,
          currency: values.pricingtype == "free" ? "" : "USD",
          price: values.price,
          updatedby: session.userid,
          eventid: session.eventid,
        },
      };

      patchRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, data: data });
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      var body = {
        resource: {
          type: "course",
          ticketname: values.coursename,
          tickettype: values.pricingtype,
          currency: "USD",
          price: values.price,
          minbooking: 1,
          maxbooking: 1,
          ticketdesc: "Internal Ticket",
          eventid: values.eventid,
          status: "internal",
          formid: values.formid,
          usercategory: values.usercategory,
          createdby: session.userid,
          updatedby: session.userid,
        },
      };

      postRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, data: data });
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
}

export function updateCoursePrice(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course`;
  var body = {
    resource: {
      courseid: values.courseid,
      ticketid: values.ticketid,
      pricingtype: values.pricingtype,
      additionalticketid: values.additionalticketid,
      isfeatured: values.isfeatured,
      eventid: session.eventid,
    },
  };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function publishedCourse(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course`;
  var body = {
    resource: {
      courseid: values.courseid,
      ispublished: values.ispublished,
      eventid: session.eventid,
    },
  };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openCourseModal(obj) {
  return { type: COURSE_MODAL, payload: obj };
}

export function clearUnpublished() {
  return {
    type: COURSE_ALL_UNPUBLISHED_LIST,
    payload: { resource: [], count: 0 },
  };
}

export function editCourse(obj) {
  return {
    type: COURSE_ALL_UNPUBLISHED_LIST,
    payload: { resource: [obj.data], count: 1 },
  };
}
